import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, renderSlot as _renderSlot, createStaticVNode as _createStaticVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/Logo-Hor-White.png';
import _imports_1 from '../assets/Logo-Vert-White.png';
const _withScopeId = n => (_pushScopeId("data-v-6aee5d28"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flex relative lg:static surface-ground" };
const _hoisted_2 = {
    id: "app-sidebar-1",
    class: "surface-section h-screen hidden lg:block flex-shrink-0 absolute lg:static left-0 top-0 z-1 border-right-1 surface-border select-none",
    style: { "width": "280px" }
};
const _hoisted_3 = { class: "flex flex-column h-full" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", {
    id: "logo-container",
    class: "flex align-items-center px-5 flex-shrink-0",
    style: { "height": "60px" }
}, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: _imports_0,
        height: "50",
        class: "mr-0 lg:mr-6"
    })
], -1));
const _hoisted_5 = { class: "overflow-y-auto" };
const _hoisted_6 = { class: "min-h-screen flex flex-column relative flex-auto" };
const _hoisted_7 = {
    id: "top-nav-container",
    class: "flex px-5 surface-0 border-bottom-1 surface-border lg:static justify-content-end",
    style: { "height": "60px" }
};
const _hoisted_8 = { class: "p-5 flex flex-column flex-auto" };
const _hoisted_9 = { class: "my-2" };
const _hoisted_10 = /*#__PURE__*/ _createStaticVNode("<div id=\"footer-container\" class=\"bg-gray-900 px-2 py-2 md:px-3 lg:px-4\" data-v-6aee5d28><div class=\"grid\" data-v-6aee5d28><div class=\"col-12 md:col-3 flex flex-wrap justify-content-start md:mb-0 mb-1\" data-v-6aee5d28><img src=\"" + _imports_1 + "\" height=\"130\" class=\"mr-0 lg:mr-6\" data-v-6aee5d28></div><div class=\"col-12 md:col-3\" data-v-6aee5d28><div class=\"text-white text-lg flex flex-wrap mb-2 font-bold\" style=\"max-width:290px;\" data-v-6aee5d28>Safe ACH LLC</div><div class=\"text-white mb-3 address-footer-container\" data-v-6aee5d28><p data-v-6aee5d28><i class=\"pi pi-envelope border-round p-1 mr-2\" data-v-6aee5d28></i>PO Box 351</p><p class=\"ml-5\" data-v-6aee5d28>Custer, SD 57730</p></div><div class=\"text-white mb-3\" data-v-6aee5d28><i class=\"pi pi-phone border-round p-1 mr-2\" data-v-6aee5d28></i>1 (877) 220-0072</div><div class=\"text-white mb-3\" data-v-6aee5d28><i class=\"pi pi-inbox border-round p-1 mr-2\" data-v-6aee5d28></i>dan@safeach.com</div></div><div class=\"col-12 md:col-3 text-gray-200\" data-v-6aee5d28><div class=\"text-white font-bold line-height-3 mb-3\" data-v-6aee5d28>Company</div><a class=\"line-height-3 block cursor-pointer mb-2\" data-v-6aee5d28>About Us</a><a class=\"line-height-3 block cursor-pointer mb-2\" data-v-6aee5d28>News</a></div><div class=\"col-12 md:col-3 text-gray-200\" data-v-6aee5d28></div></div></div>", 1);
import useMainStore from '@/store/main.store';
import useAuthStore from "@/store/auth.store";
import { determineRole } from "@/helpers/jwtHelper";
export default /*#__PURE__*/ _defineComponent({
    __name: 'AppLayoutAuthorized',
    setup(__props) {
        const items = [
            { label: 'Home', to: '/' },
            // { label: 'About', to: '/about' },
            { label: 'Contact Us', to: '/contact' }
        ];
        let navitems = [
            { label: 'Dashboard', icon: 'pi pi-home mr-2', to: '/dashboard' },
            { label: 'New Import', icon: 'pi pi-chart-line mr-2', to: '/analysis' },
            { label: 'Import History', icon: 'pi pi-chart-line mr-2', to: '/analysis-import-history' },
            { label: 'Company', icon: 'pi pi-building mr-2', to: '/company' },
        ];
        const store = useMainStore();
        const authStore = useAuthStore();
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            const _component_Menu = _resolveComponent("Menu");
            const _component_AdminMenuComponent = _resolveComponent("AdminMenuComponent");
            const _component_Menubar = _resolveComponent("Menubar");
            const _component_LoginComponent = _resolveComponent("LoginComponent");
            const _component_Toast = _resolveComponent("Toast");
            const _component_Message = _resolveComponent("Message");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _hoisted_4,
                            _createElementVNode("div", _hoisted_5, [
                                _createVNode(_component_Menu, {
                                    id: "side-nave-menu",
                                    model: _unref(navitems),
                                    class: "border-none list-none p-3 m-0"
                                }, {
                                    item: _withCtx(({ item }) => [
                                        _createVNode(_component_router_link, {
                                            style: { "text-decoration": "none" },
                                            class: "side-nav-link flex px-0 lg:px-5 py-3 align-items-center font-medium transition-colors transition-duration-550 p-ripple",
                                            to: item.to
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(item.label), 1)
                                            ]),
                                            _: 2
                                        }, 1032, ["to"])
                                    ]),
                                    _: 1
                                }, 8, ["model"]),
                                (_unref(determineRole)(_unref(authStore).token ?? '') === 'Administrator')
                                    ? (_openBlock(), _createBlock(_component_AdminMenuComponent, { key: 0 }))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_Menubar, {
                                model: items,
                                class: "border-none"
                            }, {
                                item: _withCtx(({ item }) => [
                                    _createVNode(_component_router_link, {
                                        style: { "text-decoration": "none" },
                                        class: "top-nav-link flex px-0 lg:px-5 py-3 align-items-center font-medium transition-colors transition-duration-150 p-ripple",
                                        to: item.to
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item.label), 1)
                                        ]),
                                        _: 2
                                    }, 1032, ["to"])
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_LoginComponent)
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _createVNode(_component_Toast, {
                                group: "action",
                                position: "top-right"
                            }),
                            _withDirectives((_openBlock(), _createBlock(_component_Message, {
                                severity: "error",
                                key: _unref(store).errorMsgKey
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(store).errorMsg), 1)
                                ]),
                                _: 1
                            })), [
                                [_vShow, _unref(store).errorMsg != '']
                            ]),
                            _withDirectives((_openBlock(), _createBlock(_component_Message, {
                                severity: "info",
                                key: _unref(store).infoMsgKey
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(store).infoMsg), 1)
                                ]),
                                _: 1
                            })), [
                                [_vShow, _unref(store).infoMsg != '']
                            ]),
                            _createElementVNode("div", _hoisted_9, [
                                _renderSlot(_ctx.$slots, "default")
                            ])
                        ])
                    ])
                ]),
                _hoisted_10
            ], 64));
        };
    }
});
